import { Component, OnInit, HostListener, AfterViewInit, ElementRef, ViewChild, Renderer2, Inject, OnDestroy } from '@angular/core';
import { CommonModule, DOCUMENT } from '@angular/common';
import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { ClientsTestimonalComponent } from "../../../general/clients-testimonal/clients-testimonal.component";

interface Video {
  id: string;
  title: string;
  videoUrl: string;
  thumbnail: string;
  duration?: string;
}

interface PlaylistTestimonial {
  id: string;
  playlistName: string;
  testimonial: {
    name: string;
    designation: string;
    company: string;
    content: string;
  };
  videos: Video[];
}

@Component({
  selector: 'app-testimonials',
  imports: [CommonModule, ClientsTestimonalComponent],
  standalone: true,
  templateUrl: './testimonials.component.html',
  styleUrl: './testimonials.component.scss'
})
export class TestimonialsComponent implements OnInit, OnDestroy {
  private jsonLdScript: any;
  playlists: PlaylistTestimonial[] = [
    {
      id: 'playlist-1',
      playlistName: 'Client Success Stories',
      testimonial: {
        name: 'Jhon Doe',
        designation: 'Chief Executive Officer',
        company: 'At Diligencia',
        content: 'I Wanted To Take A Moment To Thank You For The Services Your Team Has Provided. I Am Really Impressed By The Quality Of Services I Received From Kalpita Technologies (P) Ltd. You Were Right On Schedule, Charged Reasonable Prices, Were Professional & Courteous In Dealings, And Delivered Items Well Before Time. It Is Rare To Find A Service Provider With Such Professional Consistency - You Are A Valued Service Provider To Our Business And I Wouldn\'t Hesitate In Recommending You To Other Companies.'
      },
      videos: [
        {
          id: 'video-1-1',
          title: 'Project Overview',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:45'
        },
        {
          id: 'video-1-2',
          title: 'Implementation Process',
          videoUrl: 'https://www.youtube.com/embed/zqsx5lj6QkY',
          thumbnail: 'https://img.youtube.com/vi/zqsx5lj6QkY/maxresdefault.jpg',
          duration: '3:20'
        },
        {
          id: 'video-1-3',
          title: 'Final Results',
          videoUrl: 'https://www.youtube.com/embed/FzsU06QxnNY',
          thumbnail: 'https://img.youtube.com/vi/FzsU06QxnNY/maxresdefault.jpg',
          duration: '1:55'
        },
        {
          id: 'video-1-4',
          title: 'Project Overview 2',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:45'
        },
        {
          id: 'video-1-5',
          title: 'Implementation Process 2',
          videoUrl: 'https://www.youtube.com/embed/zqsx5lj6QkY',
          thumbnail: 'https://img.youtube.com/vi/zqsx5lj6QkY/maxresdefault.jpg',
          duration: '3:20'
        },
        {
          id: 'video-1-6',
          title: 'Final Results 2',
          videoUrl: 'https://www.youtube.com/embed/FzsU06QxnNY',
          thumbnail: 'https://img.youtube.com/vi/FzsU06QxnNY/maxresdefault.jpg',
          duration: '1:55'
        },
        {
          id: 'video-1-7',
          title: 'Additional Content',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:30'
        }
      ]
    },
    {
      id: 'playlist-2',
      playlistName: 'Technical Excellence',
      testimonial: {
        name: 'James',
        designation: 'Chief Executive Officer',
        company: 'At Diligencia',
        content: 'Outstanding service and professional team. The quality of work delivered exceeded our expectations. Highly recommend their expertise and commitment to excellence in every aspect of the project delivery.'
      },
      videos: [
        {
          id: 'video-2-1',
          title: 'Technical Architecture',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '4:10'
        },
        {
          id: 'video-2-2',
          title: 'Development Process',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:30'
        },
        {
          id: 'video-2-3',
          title: 'Testing & Quality',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '3:15'
        },
        {
          id: 'video-2-4',
          title: 'Deployment',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:50'
        },
        {
          id: 'video-2-5',
          title: 'Maintenance',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '1:45'
        },
        {
          id: 'video-2-6',
          title: 'Support',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:20'
        }
      ]
    },
    {
      id: 'playlist-3',
      playlistName: 'Innovation Stories',
      testimonial: {
        name: 'Henry',
        designation: 'Chief Executive Officer',
        company: 'At Diligencia',
        content: 'Excellent collaboration and timely delivery. The team showed great professionalism and technical expertise throughout our project. Their innovative approach helped us achieve our goals efficiently.'
      },
      videos: [
        {
          id: 'video-3-1',
          title: 'Innovation Overview',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '3:45'
        },
        {
          id: 'video-3-2',
          title: 'Creative Solutions',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '4:20'
        },
        {
          id: 'video-3-3',
          title: 'Future Vision',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '3:10'
        },
        {
          id: 'video-3-4',
          title: 'Technology Stack',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '2:55'
        },
        {
          id: 'video-3-5',
          title: 'Innovation Impact',
          videoUrl: 'https://www.youtube.com/embed/dQw4w9WgXcQ',
          thumbnail: 'https://img.youtube.com/vi/dQw4w9WgXcQ/maxresdefault.jpg',
          duration: '3:30'
        }
      ]
    }
  ];

  currentPlaylistIndex = 0;
  currentVideoPage = 0;
  videosPerPage = 5; // Changed to 5 videos per page

  selectedPlaylist!: PlaylistTestimonial;
  selectedVideo!: Video;
  safeVideoUrl: SafeResourceUrl | null = null;

  constructor(private sanitizer: DomSanitizer, private renderer: Renderer2,
    @Inject(DOCUMENT) private _document: Document) { }
  injectSchemaMarkup(): void {
    const testimonialSchema = {
      "@context": "https://schema.org",
      "@graph": [
        {
          "@type": "WebPage",
          "@id": "https://www.kalpitatechnologies.com/testimonials",
          "url": "https://www.kalpitatechnologies.com/testimonials",
          "name": "Testimonials — Kalpita Technologies",
          "description": "Client testimonials for Kalpita Technologies featuring video and written reviews from global business leaders across Success Stories, Technical Excellence, and Innovation Stories.",
          "isPartOf": { "@type": "WebSite", "@id": "https://www.kalpitatechnologies.com/#website" }
        },
        {
          "@type": "BreadcrumbList",
          "@id": "https://www.kalpitatechnologies.com/testimonials#breadcrumb",
          "itemListElement": [
            { "@type": "ListItem", "position": 1, "name": "Home", "item": "https://www.kalpitatechnologies.com/" },
            { "@type": "ListItem", "position": 2, "name": "Testimonials", "item": "https://www.kalpitatechnologies.com/testimonials" }
          ]
        },
        {
          "@type": "TechArticle",
          "headline": "Client Testimonials: What Business Leaders Say About Kalpita Technologies",
          "articleBody": "Kalpita Technologies' testimonials page features video and written client reviews organized across Client Success Stories, Technical Excellence, and Innovation Stories...",
          "author": { "@type": "Organization", "name": "Kalpita Technologies" },
          "publisher": {
            "@type": "Organization",
            "name": "Kalpita Technologies",
            "logo": { "@type": "ImageObject", "url": "https://www.kalpitatechnologies.com/assets/common/black-logo.png" }
          }
        },
        {
          "@type": "HowTo",
          "name": "How to Build Client Trust Like Kalpita Technologies",
          "step": [
            { "@type": "HowToStep", "text": "Deliver with Professional Consistency and On-Time Execution." },
            { "@type": "HowToStep", "text": "Demonstrate Technical Excellence Across the Full Project Lifecycle." },
            { "@type": "HowToStep", "text": "Drive Innovation with Creative Solutions." }
          ]
        },
        {
          "@type": "FAQPage",
          "mainEntity": [
            {
              "@type": "Question",
              "name": "What do clients say about Kalpita Technologies?",
              "acceptedAnswer": { "@type": "Answer", "text": "Clients praise Kalpita Technologies for professional consistency, on-time delivery, and reasonable pricing." }
            }
          ]
        },
        {
          "@type": "LocalBusiness",
          "@id": "https://www.kalpitatechnologies.com/#localbusiness",
          "name": "Kalpita Technologies — Austin Office",
          "address": {
            "@type": "PostalAddress",
            "streetAddress": "Suite #300, 3rd Floor, Building 2, 1250 South Capital of Texas Highway",
            "addressLocality": "Austin",
            "addressRegion": "TX",
            "postalCode": "78746",
            "addressCountry": "US"
          },
          "telephone": "+1-512-240-2484",
          "url": "https://www.kalpitatechnologies.com/"
        }
      ]
    };

    this.jsonLdScript = this.renderer.createElement('script');
    this.jsonLdScript.type = 'application/ld+json';
    this.jsonLdScript.text = JSON.stringify(testimonialSchema);
    this.renderer.appendChild(this._document.head, this.jsonLdScript);
  }

  removeSchemaMarkup(): void {
    if (this.jsonLdScript) {
      this.renderer.removeChild(this._document.head, this.jsonLdScript);
    }
  }
  ngOnInit(): void {
    this.injectSchemaMarkup();
    this.selectPlaylistByIndex(0);
  }
  ngOnDestroy(): void {
    this.removeSchemaMarkup();
  }

  get pagedVideos(): Video[] {
    const start = this.currentVideoPage * this.videosPerPage;
    return this.selectedPlaylist.videos.slice(start, start + this.videosPerPage);
  }

  get totalVideoPages(): number {
    return Math.ceil(this.selectedPlaylist.videos.length / this.videosPerPage);
  }

  selectPlaylistByIndex(index: number): void {
    if (index < 0) index = this.playlists.length - 1;
    if (index >= this.playlists.length) index = 0;
    this.currentPlaylistIndex = index;
    this.selectedPlaylist = this.playlists[index];
    this.currentVideoPage = 0;
    this.selectVideo(this.selectedPlaylist.videos[0]);
  }

  // --- Video paging for carousel arrows ---
  prevVideoPage(): void {
    if (this.currentVideoPage > 0) {
      this.currentVideoPage--;
      // Only navigate the carousel, don't change the currently playing video
    }
  }

  nextVideoPage(): void {
    if (this.currentVideoPage < this.totalVideoPages - 1) {
      this.currentVideoPage++;
      // Only navigate the carousel, don't change the currently playing video
    }
  }

  // --- Video select logic ---
  selectVideo(video: Video): void {
    this.selectedVideo = video;
    // Convert YouTube URLs to proper embed format
    let embedUrl = video.videoUrl;
    if (video.videoUrl.includes('youtu.be/')) {
      const videoId = video.videoUrl.split('youtu.be/')[1].split('?')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    } else if (video.videoUrl.includes('youtube.com/watch?v=')) {
      const videoId = video.videoUrl.split('v=')[1].split('&')[0];
      embedUrl = `https://www.youtube.com/embed/${videoId}`;
    }
    this.safeVideoUrl = this.sanitizer.bypassSecurityTrustResourceUrl(embedUrl);
  }

  isPlaylistActive(idx: number): boolean {
    return this.currentPlaylistIndex === idx;
  }

  isVideoSelected(vid: Video): boolean {
    return this.selectedVideo.id === vid.id;
  }

  trackByPlaylist(idx: number, playlist: PlaylistTestimonial): string {
    return playlist.id;
  }

  trackByVideo(idx: number, video: Video): string {
    return video.id;
  }
}